import { Component, Input} from '@angular/core';
import { IconBaseService } from '../../../../services/icon-base.service';
import { FormControl } from '@angular/forms';
@Component({
    selector: 'app-icon-picker',
    templateUrl: './icon-picker.component.html',
    styleUrl: './icon-picker.component.scss',
})
export class AppIconPickerComponent {
    public iconSet:string[] =[]
    @Input() formControlData: FormControl<string|null>  = new FormControl<string> ('folder-line');
    @Input() fieldSize:'size-l'|'size-m' = 'size-l'
    constructor (
      private iconBaseService:IconBaseService
    ) {
      this.iconSet = Array.from(iconBaseService.iconsStore)
    }
    ngOnInit(): void {
      this.formControlData.value? null : this.formControlData.patchValue('folder-line')
      this.formControlData.value && this.iconBaseService.iconsStore.has(this.formControlData.value)? null : this.formControlData.patchValue('folder-line')
    }
}
